<template>
  <div v-if="modelNotifiable">
    <hr/>
    <div style="">
      <payout-form-group-section-checkbox
        :label="$t('Отправить уведомление получателю')"
        v-model="model.values.sendNotification"
        @input="onSendNotificationChange"
        :disabled="disabled"></payout-form-group-section-checkbox>

      <transition name="fade">
        <div v-show="model.values.sendNotification">
          <br/>
          <payout-form-group :label="$t('Способ уведомления')"
                             :required="false"
                             :has-errors="model.errors.has('notificationChannel')">

            <dropdown-keyvalue :options="notificationChannels"
                               :placeholder="$t('Выберите способ')"
                               :disabled="disabled"
                               :value="model.values.notificationChannel"
                               @input="model.values.notificationChannel = $event"></dropdown-keyvalue>

            <payout-input-hint-block v-slot:hints :hint="model.getHint('notificationChannel')"></payout-input-hint-block>
            <error-message-block v-slot:errors attribute="notificationChannel"
                           :errors="model.errors"></error-message-block>
          </payout-form-group>

          <payout-textfield-input-group :label="$t('E-mail')" :required="true" :disabled="disabled" v-show="channelEmail" :model="model"
                                 attribute="notificationAddress"></payout-textfield-input-group>
          <payout-textfield-input-group  :label="$t('Номер телефона')" :required="true" :disabled="disabled" v-show="channelMobile" :model="model"
                                 attribute="notificationMobile"></payout-textfield-input-group>

          <payout-form-group :label="$t('Язык сообщения')"
                             :required="false"
                             v-show="channelSelected"
                             :has-errors="model.errors.has('notificationLanguage')">

            <dropdown-keyvalue :options="notificationLanguages"
                               :placeholder="$t('Выберите язык')"
                               :disabled="disabled"
                               :value="model.values.notificationLanguage"
                               @input="model.values.notificationLanguage = $event"></dropdown-keyvalue>

            <payout-input-hint-block v-slot:hints :hint="model.getHint('notificationLanguage')"></payout-input-hint-block>
            <error-message-block v-slot:errors attribute="notificationLanguage"
                           :errors="model.errors"></error-message-block>
          </payout-form-group>
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import DropdownKeyvalue from "@/components/forms/dropdown/DropdownKeyValue.vue";
import PayoutFormGroupSectionCheckbox
  from "@/components/forms/payout/formgroup/PayoutFormGroupSectionCheckbox.vue";
import {PayoutWebModel} from "capitalist-shared/src/finance/payments";

@Component({
  name: "PayoutFormNotificationBlock",
  components: {
    PayoutFormGroupSectionCheckbox,
    DropdownKeyvalue,
    PayoutTextfieldInputGroup, ErrorMessageBlock, PayoutInputHintBlock, PayoutFormGroup}
})
export default class PayoutFormNotificationBlock extends Vue{
  @Prop({required: true})
  model: PayoutWebModel

  @Prop({default: false})
  disabled: boolean

  subid = Math.random().toString(36).substring(7);

  onSendNotificationChange(value) {
    if (!value) {
      this.model.values.notificationChannel = null;
    }
  }

  get checkboxId() {
    return 'payout-form-notification-checkbox-' + this.subid;
  }

  mounted() {

    if (['ru', 'en'].includes(this.$i18n.locale)) {
      // console.log('mounted', this.$i18n.locale, this.model.values);
      this.model.values.notificationLanguage = this.$i18n.locale;
    }
  }

  get modelNotifiable(): boolean {
    return this.model && this.model.loaded
      && this.model.options.notifiable;
  }
  get channelEmail(): boolean {
    return this.model.values.notificationChannel == 'EMAIL';
  }
  get channelMobile(): boolean {
    return this.model.values.notificationChannel == 'SMS';
  }

  get channelSelected(): boolean {
    return this.model.values.notificationChannel && this.model.values.notificationChannel != '';
  }

  get notificationChannels() {
    const result = {};
    [
      {key: 'EMAIL', value: this.$t('Email')},
      {key: 'SMS', value: this.$t('SMS')}
    ].forEach((item) => {
      //if (this.model.options.notificationChannels.includes(item.key)) {
        result[item.key] = this.$t(item.value as string) as string;
      //}
    });

    return result;
  }

  get notificationLanguages() {
    const result = {};
    [
      {key: 'ru', value: this.$t('Русский')},
      {key: 'en', value: this.$t('Английский')},
    ].forEach((item) => {
      result[item.key] = item.value;
    });
    return result;
  }

  @Watch('modelNotifiable')
  onNotificableUpdate(newVal, oldVal) {
    if (newVal) {
      const val =
        '' + this.model.values.notificationAddress
        + this.model.values.notificationMobile;
      if (val.length == 0) {
        this.model.values.notificationChannel = '';
      }
    }
  }

  toggleSendNotification($event: any) {
    let self = this;
    if (!$event.target.checked) {
      // self.model.values.notificationChannel = '';
      // self.model.values.notificationAddress = '';
      // self.model.values.notificationMobile = '';
      this.$nextTick(function () {
        self.model.values.notificationChannel = '';
        self.model.values.notificationAddress = '';
        self.model.values.notificationMobile = '';
      });
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Отправить уведомление получателю": "Send notification to beneficiary",
    "Выберите способ": "Select method",
    "Способ уведомления": "Notification method",
    "Язык сообщения": "Message language",
    "Выберите язык": "Select language",
    "Русский": "Russian",
    "Английский": "English",
    "Номер телефона": "Phone number"
  }
}
</i18n>
